module.exports = __webpack_public_path__ + "img/03.d4ffeba6.jpg";